import env from "../constants/env";

/**
 * Content-bucket URL helpers that work in every region.
 *
 * Older code assumed the US bucket's global path-style URL (https://s3.amazonaws.com/content.ambifi.com/...),
 * which silently breaks in London. These helpers only recognise the configured content bucket and accept the
 * URL forms S3 produces for it: the configured prefix, global and regional path-style, and virtual-hosted style.
 */
function escapeRegExp(value) {
	return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function getContentBucketPrefix(config = env) {
	const configured = config && config.s3 && typeof config.s3.contentBucketPrefix === "string" ? config.s3.contentBucketPrefix.trim() : "";
	if (configured) {
		return configured.endsWith("/") ? configured : `${configured}/`;
	}
	const bucket = config && config.s3 ? config.s3.contentBucket : "";
	const region = config && config.aws ? config.aws.defaultRegion : "";
	return region && region !== "us-east-1" ? `https://s3.${region}.amazonaws.com/${bucket}/` : `https://s3.amazonaws.com/${bucket}/`;
}

/** Absolute URL of an object in the content bucket; the key is percent-encoded as a URL path (spaces etc.), slashes kept. */
export function contentObjectUrl(key, config = env) {
	const normalized = String(key || "").replace(/^\/+/, "");
	return `${getContentBucketPrefix(config)}${encodeURI(normalized)}`;
}

/**
 * Object key for a URL that points into the configured content bucket, or null when it does not.
 * Callers must treat null as "leave this URL alone".
 */
export function contentKeyFromUrl(url, config = env) {
	if (typeof url !== "string" || !url) {
		return null;
	}
	const bucket = config && config.s3 ? config.s3.contentBucket : "";
	if (!bucket) {
		return null;
	}
	const b = escapeRegExp(bucket);
	const patterns = [
		new RegExp(`^${escapeRegExp(getContentBucketPrefix(config))}(.+)$`, "i"),
		new RegExp(`^https?://s3(?:[.-][a-z0-9-]+)?\\.amazonaws\\.com/${b}/(.+)$`, "i"),
		new RegExp(`^https?://${b}\\.s3(?:[.-][a-z0-9-]+)?\\.amazonaws\\.com/(.+)$`, "i")
	];
	for (const pattern of patterns) {
		const match = pattern.exec(url);
		if (match) {
			const key = match[1].split("?")[0].split("#")[0];
			return key ? decodeURIComponent(key) : null;
		}
	}
	return null;
}
